import { ConversionType } from '../../utils/fractionData';

interface FractionGameDisplayProps {
  question: string;
  answer: string;
  decimal: number;
  showAnswer: boolean;
  isBlocked?: boolean;
  type: ConversionType;
}

const funnyMessages = [
  "Fractions request a moment of peace! 🧮",
  "Let's slice these numbers carefully! 🍕",
  "Your fraction enthusiasm is amazing! Take a tiny break ⭐",
  "Even percentages need to catch their breath! 💨",
  "Fraction fever! Time for a quick cooldown 🌡️",
  "Converting at warp speed? Let's slow down! 🚀",
  "The fraction fairies need a moment! 🧚‍♂️",
  "Math magic loading... Please wait! ✨"
];

export const FractionGameDisplay: React.FC<FractionGameDisplayProps> = ({
  question,
  answer,
  decimal,
  showAnswer,
  isBlocked,
  type,
}) => {
  const randomMessage = () => funnyMessages[Math.floor(Math.random() * funnyMessages.length)];

  return (
    <div className="text-center mb-8">
      <div className="bg-gradient-to-br from-rose-50 to-pink-50 dark:from-rose-900/20 dark:to-pink-900/20 p-8 rounded-xl border border-rose-100 dark:border-rose-800 transition-colors duration-200">
        <div className="space-y-4">
          <h2 className="text-5xl font-bold bg-gradient-to-r from-rose-600 to-pink-600 dark:from-rose-400 dark:to-pink-400 bg-clip-text text-transparent">
            {type === 'fraction-to-percentage' ? (
              <>Convert: {question} to percentage</>
            ) : (
              <>Convert: {question}% to fraction</>
            )}
          </h2>
          
          {showAnswer && (
            <div className="space-y-2">
              <p className="text-3xl font-bold text-gray-800 dark:text-gray-200">
                {answer}
              </p>
              <p className="text-lg text-gray-600 dark:text-gray-400">
                Decimal: {decimal.toFixed(4)}
              </p>
            </div>
          )}
        </div>
        
        <p className="text-sm font-medium text-gray-600 dark:text-gray-400 mt-4">
          {isBlocked ? (
            <span className="text-amber-600 dark:text-amber-400">{randomMessage()}</span>
          ) : (
            showAnswer ? 'Press → or Space for next question' : 'Press → or Space to see answer'
          )}
        </p>
      </div>
    </div>
  );
};